import store from "@/state/store";


//let empreConf = JSON.parse(localStorage.getItem('emprconf'))
let userLogged = JSON.parse(localStorage.getItem('user'))
let rotaDefault = import('./views_mobagile/dashboards/default')

// console.log('userLogged')
// console.log(userLogged)


if (userLogged && userLogged.tipo === 'cotacao') {
  rotaDefault = import('./views_mobagile/dashboards/fretes/index')
} else if (userLogged && userLogged.tipo === 'coletor') {
  rotaDefault = import('./views_mobagile/dashboards/coletor/index')
}

// console.log('rotaDefault')
// console.log(rotaDefault)

export default [



    {
        path: "/blank",
        name: "BlankPage",
        meta: { authRequired: true },
        component: () => import("./views_mobagile/_blank_page.vue"),
    },

    {
        path: "/testes",
        name: "TestesPage",
        meta: { authRequired: true },
        component: () => import("./views_mobagile/administrativo/testes.vue"),
    },


  {
    path: "/",
    name: "default",
    meta: { authRequired: true, },
    component: () =>  rotaDefault,
    // component: () => empreConf && empreConf.regtrib === '99' ? import("./views_mobagile/dashboards/transportador/index.vue") : import("./views_mobagile/dashboards/default"),
  },


  {
    path: "/dashboard/atendimento",
    name: "saas-dashboard",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/dashboards/saas/index"),
    // component: () => import("./views_mobagile/dashboards/transp01/index.vue"),

  },

  {
    path: "/dashboard/coletor",
    name: "coletor-dashboard",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/dashboards/coletor/index"),
  },

  {
    path: "/dashboard/analitico",
    name: "crypto-dashboard",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/dashboards/crypto/index"),
  },
  {
    path: "/dashboard/supervisao",
    name: "blog-dashboard",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/dashboards/blog/index"),
  },
  {
    path: "/dashboard/fretes",
    name: "fretes-dashboard",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/dashboards/fretes/index"),
  },
  {
    path: "/dashboard/transportador",
    name: "transp-dashboard",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/dashboards/transportador/index"),
  },
  {
    path: "/dashboard/transpestado",
    name: "transpestado-dashboard",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/dashboards/transportador/indexestado"),
  },

  {
    path: "/dashboard/transpregiao",
    name: "transpregiao-dashboard",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/dashboards/transportador/indexregiao"),
  },
  {
    path: "/dashboard/acompanhamento",
    name: "acompanhamento-dashboard",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/dashboards/acompanhamento_status/index"),
  },

  {
    path: "/dashboard/mapaentregas",
    name: "dashentregas",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/dashboards/dashpyext/dashmapafretes01.vue"),
  },
  {
    path: "/dashboard/mapaeficentr",
    name: "eficentrega",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/dashboards/dashpyext/dashmapafretes02.vue"),
  },

  {
    path: "/controleentregas/controle-entrega",
    name: "controleentrega-motorista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/controleentregas/index"),
  },

  {
    path: "/entrega-alterada/prev-alterada",
    name: "movdataagendamento",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movagendamento/movimento-data-agendamento"),
  },


  {
    path: "/cotacaofretesbase/list",
    name: "CotacaoFretesBaseList",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/cotacaofretes/cotacaofretesbase-list"),
  },
  {
    path: "/cotacaofretesbase/editar/:id",
    name: "CotacaoFretesBaseEdit",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/cotacaofretes/cotacaofretesbase-editar"),
  },
  {
    path: "/cotacaofretesbase/editar",
    meta: { authRequired: true },
    redirect: "/cotacaofretesbase/list"
  },


  {
    path: "/cotacaofretesbasetab/editar/:id",
    name: "CotacaoFretesBaseTabEdit",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/cotacaofretes/cotacaofretesbasetab-editar"),
  },
  {
    path: "/cotacaofretesbasetab/editar",
    meta: { authRequired: true },
    redirect: "/cotacaofretesbase/list"
  },


  {
    path: "/cotacaofretesbasetrttda/list",
    name: "CotacaoFretesBaseTrtTdaList",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/cotacaofretes/cotacaofretesbasetrttda-list.vue"),
  },
  {
    path: "/cotacaofretesbasetde/list",
    name: "CotacaoFretesBaseTdeList",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/cotacaofretes/cotacaofretesbasetde-list.vue"),
  },
  {
    path: "/cotacaofretesbasetde/editar/:id",
    name: "CotacaoFretesBaseTdeEdit",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/cotacaofretes/cotacaofretesbasetde-editar"),
  },
  {
    path: "/cotacaofretesbasetde/editar",
    meta: { authRequired: true },
    redirect: "/cotacaofretesbasetde/list"
  },



  {
    path: "/cotacaofretesbaseelk/list",
    name: "CotacaoFretesBaseElkList",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/cotacaofretes/cotacaofretesbaseelk-list"),
  },
  {
    path: "/cotacaofretesbasetabelk/editar/:id",
    name: "CotacaoFretesBaseTabELKEdit",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/cotacaofretes/cotacaofretesbaseelk-editar"),
  },
  {
    path: "/cotacaofretesbasetabelk/editar",
    meta: { authRequired: true },
    redirect: "/cotacaofretesbaseelk/list"
  },
  {
    path: "/cotacaofretesbaseelk/editar/:id",
    name: "CotacaoFreteBaseElkEdit",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/cotacaofretes/cotacaofretebaseelk-editar"),
  },
  {
    path: "/cotacaofretesbaseelk/editar",
    meta: { authRequired: true },
    redirect: "/cotacaofretesbaseelk/list"
  },


    {
        path: "/cotacaofretesbaseelk/impadrao/:id",
        name: "CotacaoFreteBaseElkImpPadrao",
        meta: { authRequired: true },
        component: () => import("./views_mobagile/cotacaofretes/cotacaofretebaseelk-imp-padrao"),
    },

    {
        path: "/cotacaofretesbaseelk/impadrao",
        meta: { authRequired: true },
        redirect: "/cotacaofretesbaseelk/list"
    },





  {
    path: "/arquivos",
    name: "Arquivos",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/arquivos/arquivos-list"),
  },

  {
    path: "/logdispemail",
    name: "LogDispEmail",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/logs/logdispemail"),
  },

  {
    path: "/atendimentos/listprod",
    name: "AtendListaProd",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/atendimento_prod/chats-list"),
  },
  {
    path: "/atendimentos/list",
    name: "AtendLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/atendimento/atendimentos-list"),
  },
  {
    path: "/atendimentos/chat",
    name: "AtendChat",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/atendimento/chat"),
  },
  {
    path: "/atendimentos/config",
    name: "AtendConfig",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/atendimento/configuracao"),
  },
  {
    path: "/atendimento/detalhes/:id",
    name: "AtendDetalhes",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/atendimento_prod/chat-detalhes"),
  },
  {
    path: "/atendimento/mensagens",
    name: "AtendMensagens",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/atendimento_prod/mensagens"),
  },


  {
    path: "/calendario",
    name: "Calendario",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/calendario/calendario"),
  },


  {
    path: "/ccorrentes/list",
    name: "CcorrenteLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/contascorrentes/ccorrentes-list.vue"),
  },

  {
    path: "/cbancs/list",
    name: "CbancLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/contascorrentes/ccorrentes-list.vue"),
  },

  {
    path: "/clientes/list",
    name: "ClienteLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/clientes/clientes-list"),
  },
  {
    path: "/clientes/listnova",
    name: "ClienteListaNova",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/clientes/clientes-list-nova"),
  },
  {
    path: "/cliente/detalhe/:id",
    name: "ClienteDetalhe",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/clientes/cliente-detalhe"),
  },
  {
    path: "/cliente/editar/:id",
    name: "ClienteEditar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/clientes/cliente-editar"),
  },
  {
    path: "/cliente/editar",
    meta: { authRequired: true },
    redirect: "/clientes/list"
  },
  {
    path: "/cliente/detalhe",
    meta: { authRequired: true },
    redirect: "/clientes/list"
  },
  {
    path: "/clientes/pesquisa",
    name: "ClientePesquisa",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/clientes/clientes-pesquisa"),
  },
  {
    path: "/clientes/leads",
    name: "ClienteLeads",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/clientes/leads/clientes-leads.vue"),
  },
  {
    path: "/clientes/comunicacao",
    name: "ClienteComunicacao",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/clientes/comunicacao/comunicacao-list.vue"),
  },
  {
    path: "/clientes/readmsg",
    meta: { authRequired: true },
    redirect: "/clientes/comunicacao"
  },

  {
    path: "/transportadoras/list",
    name: "TransportadoraLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/clientes/clientes-list"),
  },



  {
    path: "/contratos/list",
    name: "ContratoLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/contratos/contratos-list"),
  },
  {
    path: "/contrato/editar/:id",
    name: "ContratoEditar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/contratos/contrato-editar"),
  },
  {
    path: "/contrato/editar",
    meta: { authRequired: true },
    redirect: "/contratos/list"
  },


  {
    path: "/orcamento/cotarfrete/:id",
    name: "CotarFrete",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/cotarfrete/cotar-frete-editar.vue"),
  },


  {
    path: "/cotafrts/listnova",
    name: "CotarFrtListaNova",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/cotarfrete/cotar-frete-list-nova"),
  },
  {
    path: "/cotafrts/listinterna",
    name: "CotarFrtListaInterna",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/cotarfrete/cotar-frete-list-interna"),
  },
  {
    path: "/cotafrts/listexterna",
    name: "CotarFrtListaExterna",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/cotarfrete/cotar-frete-list-externa"),
  },
  {
    path: "/cotafrts/list",
    name: "CotarFrtLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/cotarfrete/cotar-frete-list"),
  },
  {
    path: "/cotafrt/editar/:id",
    name: "CotarFrtEditar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/cotarfrete/cotar-frete-editar"),
  },
  {
    path: "/cotafrt/editar",
    meta: { authRequired: true },
    redirect: "/cotafrts/list"
  },

  {
    path: "/cotafrtdeds/listdedicada",
    name: "CotarFrtListaDedicada",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/cotarfrete/cotar-frete-list-dedicada"),
  },
  {
    path: "/cotafrtded/editarded/:id",
    name: "CotarFrtEditarDedicada",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/cotarfrete/cotar-frete-editar-dedicada"),
  },
  {
    path: "/cotafrtded/editarded",
    meta: { authRequired: true },
    redirect: "/cotafrtdeds/listdedicada"
  },

  {
    path: "/gestaoprojeto",
    name: "GestaoProjeto",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/gestaoprojeto/gestaoprojeto"),
  },
  {
    path: "/gpresources",
    name: "GPResources",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/gestaoprojeto/resources-list"),
  },


  {
    path: "/impressoras/list",
    name: "ImpressoraLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/impressoras/impressoras-list"),
  },


  {
    path: "/nota/editar",
    meta: { authRequired: true },
    redirect: "/compras/list"
  },

  {
    path: "/empresas/list",
    name: "EmpreLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/empresas/empresas-list"),
  },
  {
    path: "/empresa/editar/:id",
    name: "EmpresaEditar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/empresas/empresa-editar"),
  },
  {
    path: "/empresa/editar",
    meta: { authRequired: true },
    redirect: "/empresas/list"
  },


  {
    path: "/movctes/list",
    name: "CteLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movcte/cte-entrada-list"),
  },
  {
    path: "/movctes/listnova",
    name: "CteListaNova",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movcte/cte-list"),
  },


  {
    path: "/movcte/importar/:id",
    name: "MovCteImpXML",
    meta: { authRequired: true },
    props: true,
    component: () => import("./views_mobagile/movcte/importar-xml-cte"),
  },
  {
    path: "/movcte/importar",
    meta: { authRequired: true },
    redirect: "/movctes/list"
  },

  {
    path: "/movcte/editar/:id",
    name: "MovCteEditar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movcte/cte-editar-nova"),
  },
  {
    path: "/movcte/editar",
    meta: { authRequired: true },
    redirect: "/movctes/list"
  },

  {
    path: "/movctesfiscal/list",
    name: "CteFiscalLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movcte-fiscal/movcte-fiscal-listar"),
  },
  {
    path: "/movctefiscal/editar/:id",
    name: "MovCteFiscalEditar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movcte-fiscal/movcte-fiscal-editar"),
  },
  {
    path: "/movctefiscal/editar",
    meta: { authRequired: true },
    redirect: "/movctesfiscal/list"
  },


    {
        path: "/movctecotassinc/list",
        name: "CteCotaAssincLista",
        meta: { authRequired: true },
        component: () => import("./views_mobagile/movcte/cte-list-cota-assinc.vue"),
    },
    {
        path: "/movctecompassinc/list",
        name: "CteCompAssincLista",
        meta: { authRequired: true },
        component: () => import("./views_mobagile/movcte/cte-list-comp-assinc.vue"),
    },
    {
        path: "/movctecotacomps/list",
        name: "CteCotaCompLista",
        meta: { authRequired: true },
        component: () => import("./views_mobagile/movcte/cte-list-cotacoes-assinc.vue"),
    },

    {
        path: "/fretecotacomp/list",
        name: "FreteCotaCompLista",
        meta: { authRequired: true },
        component: () => import("./views_mobagile/movcte/cte-list-frete-cota-comp.vue"),
    },


  {
    path: "/movmdfesfiscal/list",
    name: "MdfeFiscalLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movmdfe-fiscal/movmdfe-fiscal-listar"),
  },
  {
    path: "/movmdfefiscal/editar/:id",
    name: "MovMdfeFiscalEditar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movmdfe-fiscal/movmdfe-fiscal-editar"),
  },
  {
    path: "/movmdfefiscal/editar",
    meta: { authRequired: true },
    redirect: "/movmdfesfiscal/list"
  },

  {
    path: "/caixas/list",
    name: "CaixasLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/caixas/caixas-list"),
  },

  {
    path: "/caixa/editar/:id",
    name: "CaixaEditar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/caixas/caixa-editar"),
  },


  {
    path: "/categorias/list",
    name: "CategoriaLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/categorias/categorias-list"),
  },

  {
    path: "/categoria/editar/:id",
    name: "CategoriaEditar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/categorias/categoria-editar"),
  },

  {
    path: "/condicoes/list",
    name: "CondicaoLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/condicoes/condicoes-list"),
  },

  {
    path: "/cfop/list",
    name: "CfopLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/cfop/cfop-list"),
  },

  {
    path: "/estados/list",
    name: "EstadoLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/estados/estados-list"),
  },

  {
    path: "/faltapermissao",
    name: "FaltaPermissao",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/paginas/falta-parametro"),
  },

  {
    path: "/fretecotas/list",
    name: "FreteCotasLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/administrativo/fretecota-list"),
  },

  /*{
    path: "/ccorrente/list",
    name: "CCorrente",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/financeiro/contacorrente"),
  },*/

  {
    path: "/extratofinanc/list",
    name: "ExtratoFinanc",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/financeiro/extratofinanc"),
  },


  /*{
    path: "/fincaixa/list",
    name: "FinanCaixa",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/financeiro/caixa"),
  },*/

  /*{
    path: "/fluxocaixa/list",
    name: "Fluxocaixa",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/financeiro/fluxocaixa")
  },*/

  {
    path: "/financeiros/contasreceber",
    name: "CReceberLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/contasreceber/contasreceber-list-nova"),
  },
  {
    path: "/financeiros/contasreceberdetalhado",
    name: "CReceberListaDetalhado",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/contasreceber/contasreceber-detalhado-list"),
  },
  {
    path: "/creceber/editar/:id",
    name: "CReceberEditar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/contasreceber/contareceber-editar"),
  },
  {
    path: "/creceber/editar",
    meta: { authRequired: true },
    redirect: "/financeiros/contasreceber"
  },

  {
    path: "/financeiros/contaspagar",
    name: "CpagarLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/contaspagar/contaspagar-list-nova"),
  },
  {
    path: "/financeiros/contaspagardetalhado",
    name: "CpagarListaDetalhado",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/contaspagar/contaspagar-detalhado-list"),
  },
  {
    path: "/cpagar/editar/:id",
    name: "CPagarEditar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/contaspagar/contapagar-editar"),
  },
  {
    path: "/cpagar/editar",
    meta: { authRequired: true },
    redirect: "/financeiros/contaspagar"
  },



  {
    path: "/enderecos/list",
    name: "EnderLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/enderecos/enderecos-list"),
  },
  {
    path: "/enderecos/3D",
    name: "Ender3D",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/enderecos/enderecos-estoque-3d.vue"),
  },

  {
    path: "/paletes/list",
    name: "PaletesLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/paletes/paletes-list"),
  },

  {
    path: "/financeiros/despesas",
    name: "DespeLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/financeiro/despesas-list.vue"),
  },
  {
    path: "/financeiros/receitas",
    name: "ReceiLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/financeiro/receitas-list"),
  },
  {
    path: "/financeiros/comissoes",
    name: "ComissLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/financeiro/comissoes"),
  },
  {
    path: "/financeiros/vouchers",
    name: "VouchersLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/financeiro/vouchers-list.vue"),
  },
  {
    path: "/financeiros/doccobs",
    name: "DocCobLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/doccob/doccobs-list"),
  },
  {
    path: "/doccob/editar/:id",
    name: "DocCobEditar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/doccob/doccob-detalhe"),
  },
  {
    path: "/doccob/editar",
    meta: { authRequired: true },
    redirect: "/financeiros/doccobs"
  },


  {
    path: "/formas/list",
    name: "FormaLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/formas/formas-list"),
  },


  {
    path: "/instwhats/list",
    name: "InstWhatsLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/whatsapp/instancias"),
  },


  {
    path: "/loja/produtos",
    name: "ProdListaLoja",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/loja/produtos-list"),
  },
  {
    path: "/loja/produto-detalhe/:id",
    name: "ProdDetalhe",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/loja/produto-detalhe"),
  },
  {
    path: "/loja/carrinho",
    name: "Carrinho",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/loja/carrinho"),
  },
  {
    path: "/loja/pagamento",
    name: "Pagamento",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/loja/pagamento"),
  },



  {
    path: "/mapas/list",
    name: "MapaLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/mapas/index"),
  },

  {
    path: "/mesas/list",
    name: "MesaLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/mesas/mesas-list"),
  },
  {
    path: "/mesa/detalhe/:id",
    name: "MesaDetalhe",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/mesas/mesa-editar"),
  },
  {
    path: "/mesa/editar/:id",
    name: "MesaEditar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/mesas/mesa-editar"),
  },


  {
    path: "/notificacoes/list",
    name: "NatuLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/notificacoes/notificacoes-list"),
  },

  {
    path: "/naturezas/list",
    name: "NotifLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/naturezas/naturezas-list"),
  },
  {
    path: "/natureza/editar/:id",
    name: "NaturezaEditar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/naturezas/natureza-editar"),
  },
  {
    path: "/natureza/editar",
    meta: { authRequired: true },
    redirect: "/naturezas/list"
  },




  {
    path: "/notasinuteis/list",
    name: "NotaInutLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/notasinuteis/notasinuteis-list"),
  },


  {
    path: "/ocorrencias/list",
    name: "OcorenciasLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/administrativo/ocorrencias-list"),
  },

  {
    path: "/ocorfinais/list",
    name: "OcorFinaisLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/administrativo/ocorfinais-list"),
  },

  {
    path: "/forminbound/editar",
    name: "InboundForm",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/administrativo/inbound-form"),
  },

  {
    path: "/orcamentos/list",
    name: "OrctoLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/orcamentos/orcamentos-list-nova"),
  },

  {
    path: "/orcamentos/listOld",
    name: "OrctoListaOld",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/orcamentos/orcamentos-list"),
  },


  {
    path: "/orcamento/detalhe/:id",
    name: "OrctoDetalhe",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/orcamentos/orcamento-detalhe"),
  },
  {
    path: "/orcamento/detalhesecao/:id",
    name: "OrctoDetalheSecao",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/orcamentos/orcamento-editar"),
  },
  {
    path: "/orcamento/editar/:id",
    name: "OrctoEditar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/orcamentos/orcamento-editar-nova"),
  },
  {
    path: "/orcamento/editar/:idOld",
    name: "OrctoEditarOld",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/orcamentos/orcamento-editar"),
  },
  {
    path: "/orcamento/editar",
    meta: { authRequired: true },
    redirect: '/orcamentos/list'
  },
  {
    path: "/orcamento/impressao/:id",
    name: "OrctoImprimir",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/orcamentos/orcamento-impressao"),
  },
  {
    path: "/orcamento/impressao",
    meta: { authRequired: true },
    redirect: '/orcamentos/list'
  },


  {
    path: "/pedidos/list",
    name: "PedidoLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/pedidos/pedidos-list-nova"),
  },
  {
    path: "/pedidos/listold",
    name: "PedidoListaOld",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/pedidos/pedidos-list"),
  },
  {
    path: "/pedido/detalhe/:id",
    name: "PedidoDetalhe",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/pedidos/pedido-detalhe"),
  },
  {
    path: "/pedido/impressao/:id",
    name: "PedidoImpressao",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/pedidos/pedido-impressao"),
  },
  {
    path: "/pedido/detalhe",
    meta: { authRequired: true },
    redirect: "/pedidos/list"
  },
  {
    path: "/pedido/importar/:id",
    name: "PedidoImpXML",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/pedidos/importar-xml-pedido"),
  },
  {
    path: "/pedido/dashmeli",
    name: "DashMercadoLivre",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/mercadolivre/dashboard/index"),
  },
  {
    path: "/pedidos/listmeli",
    name: "PedidosMercadoLivre",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/mercadolivre/pedidos-list"),
  },
  {
    path: "/pedido/pedmeli/:id",
    name: "PedidoMercadoLivre",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/mercadolivre/pedido-detalhe"),
  },
  {
    path: "/pedido/pedmeli",
    meta: { authRequired: true },
    redirect: "/pedidos/listmeli"
  },



  {
    path: "/pedidos/anymarket",
    name: "PedidosAnyMarket",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movanymarket/movanymarket-list.vue"),
  },
  {
    path: "/pedido/anymarket/:id",
    name: "PedidoAnyMarket",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movanymarket/movanymarket-editar.vue"),
  },
  {
    path: "/pedido/anymarket",
    meta: { authRequired: true },
    redirect: "/pedidos/anymarket"
  },


  {
    path: "/pedidos/bling",
    name: "PedidosBling",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movbling/movbling-list.vue"),
  },
  // {
  //   path: "/pedido/bling/:id",
  //   name: "PedidoBling",
  //   meta: { authRequired: true },
  //   component: () => import("./views_mobagile/movbling/movbling-editar.vue"),
  // },

  {
    path: "/pedidos/vindi",
    name: "PedidosVindi",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movyapay/movyapay-list-nova.vue"),
  },
  // {
  //   path: "/pedido/movyapay/:id",
  //   name: "PedidoYapay",
  //   meta: { authRequired: true },
  //   component: () => import("./views_mobagile/movyapay/movyapay-editar.vue"),
  // },
  {
    path: "/pedido/vindi",
    meta: { authRequired: true },
    redirect: "/pedidos/vindi"
  },
  // {
  //   path: "/pedido/movyapay",
  //   meta: { authRequired: true },
  //   redirect: "/pedidos/movyapay"
  // },


  {
    path: "/pedido/pdv",
    name: "PDV",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movpdv/mov-pdv-editar"),
  },


  {
    path: "/movspdv/list",
    name: "PdvLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movpdv/mov-pdv-list"),
  },
  {
    path: "/movpdv/editar/:id",
    name: "MovPdvEditar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movpdv/mov-pdv-editar"),
  },
  {
    path: "/movpdv/editar",
    meta: { authRequired: true },
    redirect: "/movpdv/list"
  },

  {
    path: "/movsshopeetrk/list",
    name: "MovShopeeLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/moshopee/movshopeetrk-list.vue"),
  },

    {
        path: "/movsshopeeelk/list",
        name: "MovShopeeListaElk",
        meta: { authRequired: true },
        component: () => import("./views_mobagile/pedidos-shopee/pedidos-shopee-list.vue"),
    },

  {
    path: "/movshptrkfins/list",
    name: "MovShopeeFinanceiroLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/moshopee/movshptrkfins-list.vue"),
  },




  {
    path: "/produtos/listestoque",
    name: "ProdutoEstoque",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/produtos/produtoslote-list-nova"),
  },

  {
    path: "/produtos/listestoqueold",
    name: "ProdutoEstoqueOld",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/produtos/produtoslote-list"),
  },

  {
    path: "/produtos/listestoqender",
    name: "ProdutoEstoqueEndereco",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/produtos/produtos-estoque-endereco.vue"),
  },

  {
    path: "/produtos/list",
    name: "ProdutoLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/produtos/produtos-list"),
  },
  {
    path: "/produto/detalhe/:id",
    name: "ProdutoDetalhe",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/produtos/produto-detalhe"),
  },
  {
    path: "/produto/editar/:id",
    name: "ProdutoEditar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/produtos/produto-editar"),
  },
  {
    path: "/produto/editar",
    meta: { authRequired: true },
    redirect: "/produtos/list"
  },
  {
    path: "/produto/detalhe",
    meta: { authRequired: true },
    redirect: "/produtos/list"
  },

  {
    path: "/prodfabrics/list",
    name: "ProdFabricLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/produtosfabricantes/produtos-fabricantes-list"),
  },

  {
    path: "/prodclfiscais/list",
    name: "ProdClFiscalLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/produtosclfiscais/produtos-clfiscais-list"),
  },

  {
    path: "/prodgrupos/list",
    name: "ProdGrupoLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/produtosgrupos/produtos-grupos-list"),
  },

  {
    path: "/prodsubgrupos/list",
    name: "ProdSubGrupoLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/produtossubgrupos/produtos-sub-grupos-list"),
  },



  {
    path: "/postagens/list",
    name: "PostLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/postagens/postagens-list"),
  },
  {
    path: "/postagem/detalhe/:id",
    name: "PostDetalhe",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/postagens/postagem-detalhe"),
  },
  {
    path: "/postagem/editar/:id",
    name: "PostEditar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/postagens/postagem-editar"),
  },



  {
    path: "/projetos/list",
    name: "ProjLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/projetos/projetos-list"),
  },
  {
    path: "/projeto/detalhe/:id",
    name: "ProjDetalhe",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/projetos/projeto-detalhe"),
  },
  {
    path: "/projeto/editar/:id",
    name: "ProjEditar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/projetos/projeto-editar"),
  },
  {
    path: "/projeto/aprovar/:id",
    name: "ProjAprovar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/projetos/projeto-aprovar"),
  },
  {
    path: "/projeto/tarefas/:id",
    name: "ProjTarefas",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/projetos/projeto-editar-tarefas"),
  },

  {
    path: "/recfacial/list",
    name: "RFaceLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/recfacial/recsfacial-list"),
  },

  {
    path: "/relatsadm/list",
    name: "RelatAdm",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/relatoriosadm/relatorios-list"),
  },

  {
    path: "/relatsadm/relatadmin",
    name: "RelatAdmin",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/relatoriosadm/relatorio-administrativo"),
  },

  {
    path: "/cadastros/relatcadastro",
    name: "RelatCadastro",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/relatoriosadm/relatorio-cadastro"),
  },

  {
    path: "/crm/relatcrm",
    name: "RelatCrm",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/relatoriosadm/relatorio-crm"),
  },

  {
    path: "/estoque/relatestoque",
    name: "RelatEstoque",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/relatoriosadm/relatorio-estoque"),
  },

  {
    path: "/financeiros/relatfinanc",
    name: "RelatFinanc",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/relatoriosadm/relatorio-financeiro"),
  },

  {
    path: "/fiscal/relatfiscal",
    name: "RelatFiscal",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/relatoriosadm/relatorio-fiscal"),
  },

  {
    path: "/fretes/relatfrete",
    name: "RelatFrete",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/relatoriosadm/relatorio-frete"),
  },

  {
    path: "/orcamentos/relatorcto",
    name: "RelatOrcto",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/relatoriosadm/relatorio-orcamento"),
  },

  {
    path: "/pedidos/relatpeds",
    name: "RelatPeds",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/relatoriosadm/relatorio-pedido"),
  },

  {
    path: "/produtos/relatproduto",
    name: "RelatProduto",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/relatoriosadm/relatorio-produto"),
  },

  {
    path: "/servicos/relatservico",
    name: "RelatServico",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/relatoriosadm/relatorio-servico"),
  },

  {
    path: "/wms/relatwms",
    name: "RelatWms",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/relatoriosadm/relatorio-wms"),
  },

  {
    path: "/repres/list",
    name: "RepresLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/representantes/representantes-list"),
  },


  {
    path: "/comissoes/list",
    name: "ComissoesLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/comissoes/comissoes-list"),
  },

  {
    path: "/comissoes/calc",
    name: "ComissCalc",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/comissoes/comissoes-calc"),
  },

  {
    path: "/suporte/chamados",
    name: "SuportePage",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/suporte/chamados"),
  },
  {
    path: "/chamado/editar/:id",
    name: "ChamadoEditar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/suporte/chamado-editar.vue"),
  },
  {
    path: "/chamado/editar",
    meta: { authRequired: true },
    redirect: "/suporte/chamados"
  },


  {
    path: "/suporte/material",
    name: "SuptMaterial",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/suporte/material-apoio"),
  },
  {
    path: "/suporte/material2",
    name: "SuptMaterial2",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/suporte/material-apoio2"),
  },
  {
    path: "/suporte/material3",
    name: "SuptMaterial3",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/suporte/material-apoio3"),
  },
  {
    path: "/suporte/material4",
    name: "SuptMaterial4",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/suporte/material-apoio4"),
  },
  {
    path: "/suporte/postagem",
    name: "SuptPosategem",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/suporte/postagem"),
  },
  {
    path: "/suporte/pesquisa",
    name: "SuptPesquisa",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/suporte/pesquisa"),
  },


  {
    path: "/tabprecos/list",
    name: "TabPrecoLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/tabelasprecos/tabprecos-list"),
  },
  {
    path: "/tabpreco/editar/:id",
    name: "TabPrecoEditar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/tabelasprecos/tabpreco-editar"),
  },
  {
    path: "/tabpreco/editar",
    meta: { authRequired: true },
    redirect: "/tabprecos/list"
  },

  {
    path: "/tiposopera/list",
    name: "TpOperaLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/tiposopera/tiposopera-list"),
  },
  {
    path: "/tipoopera/editar/:id",
    name: "TipOprEditar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/tiposopera/tipoopera-editar"),
  },
  {
    path: "/tipoopera/editar",
    meta: { authRequired: true },
    redirect: "/tiposopera/list"
  },


  {
    path: "/trackerevents/list",
    name: "TrackerEventLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/trackerevents/tracker-event-list"),
  },
  {
    path: "/trackermsgss/list",
    name: "TrackerMsgsLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/trackerevents/tracker-mensagens-list"),
  },



  {
    path: "/movimentos/listnv",
    name: "MovListSyncfusion",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/mov/movimentos-list-syncfusion"),
  },
  {
    path: "/projetos/listnv",
    name: "ProjListSyncfusion",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/projetos/projetos-list-syncfusion"),
  },
  {
    path: "/chamados/listnv",
    name: "ChamadosListSyncfusion",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/chamados/chamados-list-syncfusion"),
  },
  {
    path: "/diagramas/listnv",
    name: "DiagramaListSyncfusion",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/chamados/diagrama-syncfusion"),
  },



    {
        path: "/marketplace/list",
        name: "MarketplaceLista",
        meta: { authRequired: true },
        component: () => import("./views_mobagile/marketplace_transp/marketplace-list.vue"),
    },


    {
        path: "/minutas/list",
        name: "MinutaLista",
        meta: { authRequired: true },
        component: () => import("./views_mobagile/minutas/minuta-listar.vue"),
    },
    {
        path: "/minuta/editar/:id",
        name: "MinutaEditar",
        meta: { authRequired: true },
        component: () => import("./views_mobagile/minutas/minuta-editar.vue"),
    },
    {
        path: "/minuta/editar",
        meta: { authRequired: true },
        redirect: "/minutas/list"
    },



  {
    path: "/movimentos/listgrid",
    name: "MovListaGrid",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/mov/movimentos-list-grid"),
  },
  {
    path: "/movimentos/listnova",
    name: "MovListaNova",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/mov/movimentos-list-nova"),
  },
  {
    path: "/movimentos/liststatus",
    name: "MovListaStatus",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/mov/movimentos-status-list"),
  },


  {
    path: "/movimentos/list",
    name: "MovLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/mov/movimentos-list"),
  },
  {
    path: "/movimento/importar/:id",
    name: "MovImpXML",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/mov/movimentos-importar-xml"),
  },


  {
    path: "/movimento/editar/:id",
    name: "MovEditar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/mov/movimento-editar"),
  },
  {
    path: "/movimento/editar",
    meta: { authRequired: true },
    redirect: "/movimentos/listnova"
  },
  {
    path: "/movimento/cotarinterno/:id",
    name: "MovCotarInterno",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/mov/movimento-cotar-interno"),
  },
  {
    path: "/movimento/cotarinterno",
    meta: { authRequired: true },
    redirect: "/movimentos/listnova"
  },


  // {
  //   path: "/movajuste/editar/:id",
  //   name: "MovAjtEditar",
  //   meta: { authRequired: true },
  //   component: () => import("./views_mobagile/movajuste/movajuste-editar.vue"),
  // },
  // {
  //   path: "/movajuste/editar",
  //   meta: { authRequired: true },
  //   redirect: "/transf/list"
  // },



  {
    path: "/movajustes/list",
    name: "MovAjtLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movajuste/movajuste-list-nova"),
  },
  {
    path: "/movajustes/list-old",
    name: "MovAjtLista-Old",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movajuste/movajuste-list"),
  },
  {
    path: "/movajuste/editar/:id",
    name: "MovAjtEditar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movajuste/movajuste-editar.vue"),
  },
  {
    path: "/movajuste/editar",
    meta: { authRequired: true },
    redirect: "/transf/list"
  },



  {
    path: "/movcompras/list",
    name: "MovComprasLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movcompra/compras-list-nova.vue"),
  },
  {
    path: "/movcompras/listnovaold",
    name: "MovComprasListaOld",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movcompra/compras-list.vue"),
  },
  {
    path: "/movcompras/monitora",
    name: "MovComprasMonit",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/estoque/monitora-list"),
  },
  {
    path: "/movcompras/posicionamento",
    name: "MovComprasPosic",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/estoque/posicionamento"),
  },
  {
    path: "/movcompras/carregamento",
    name: "MovComprasCarreg",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/estoque/carregamento"),
  },
  {
    path: "/movcompra/editar/:id",
    name: "MovCompraEditar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movcompra/compra-editar.vue"),
  },
{
    path: "/movcompra/confirmar/:id",
    name: "MovCompraConfirmar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movcompra/compra-confirmar.vue"),
},
  {
    path: "/movcompra/editar",
    meta: { authRequired: true },
    redirect: "/compras/list"
  },
  {
    path: "/movcompra/importar/:id",
    name: "CompraImpXML",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movcompra/importar-xml-compra.vue"),
  },


  {
    path: "/movdevols/list",
    name: "MovDevolLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movdevolucao/movdevolucoes-list"),
  },
  {
    path: "/movdevol/editar/:id",
    name: "MovDevolEditar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movdevolucao/movdevolucao-editar"),
  },
  {
    path: "/movdevol/editar",
    meta: { authRequired: true },
    redirect: "/movdevols/list"
  },


  {
    path: "/movinvents/list",
    name: "MovInventLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movinventario/inventario-list"),
  },
  {
    path: "/movinvent/editar/:id",
    name: "MovInventEditar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movinventario/inventario-editar"),
  },
  {
    path: "/movinvent/editar",
    meta: { authRequired: true },
    redirect: "/movinvents/list"
  },


  {
    path: "/movservs/list",
    name: "MovServLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movservico/movservicos-list"),
  },
  {
    path: "/movserv/editar/:id",
    name: "MovServEditar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movservico/movservico-editar"),
  },
  {
    path: "/movserv/editar",
    meta: { authRequired: true },
    redirect: "/movservs/list"
  },

  {
    path: "/pedidos/tray",
    name: "MovTrayLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movtray/movtray-list.vue"),
  },

  {
    path: "/pedidos/tiny",
    name: "MovTinyLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movtiny/movtiny-list.vue"),
  },
  
  {
    path: "/correioslogrev/list",
    name: "CorreiosLogReversa",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movservico/correiologrev-list.vue"),
  },


  {
    path: "/movtransfs/list",
    name: "MovTransfLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movtransferencia/transferencias-list"),
  },
  {
    path: "/movtransf/editar/:id",
    name: "MovTransfEditar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movtransferencia/transferencias-editar"),
  },
  {
    path: "/movtransf/editar",
    meta: { authRequired: true },
    redirect: "/movtransfs/list"
  },

  {
    path: "/processamentos/list",
    name: "ProcessaLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/processamento/processamentos-list"),
  },


    {
        path: "/roteirizador/list",
        name: "RoteirizadorLista",
        meta: { authRequired: true },
        component: () => import("./views_mobagile/roteirizador/roteirizador-list.vue"),
    },


  {
    path: "/usuarios/list",
    name: "UsuarioLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/usuarios/usuarios-list"),
  },
  {
    path: "/usuario/detalhe/:id",
    name: "UsuarioDetalhe",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/usuarios/usuario-detalhe"),
  },
  {
    path: "/usuario/editar/:id",
    name: "UsuarioEditar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/usuarios/usuario-editar"),
  },
  {
    path: "/usuario/perfil/:id",
    name: "UsuarioPerfil",
    component: () => import("./views_mobagile/usuarios/usuario-perfil"),
  },
  {
    path: "/usuario/editar",
    meta: { authRequired: true },
    redirect: "/usuarios/list"
  },
  {
    path: "/usuario/detalhe",
    meta: { authRequired: true },
    redirect: "/usuarios/list"
  },

    {
        path: "/veiculos/list",
        name: "VeiculoLista",
        meta: { authRequired: true },
        component: () => import("./views_mobagile/veiculos/veiculos-list.vue"),
    },
    {
        path: "/veiculo/editar/:id",
        name: "VeiculoEditar",
        meta: { authRequired: true },
        component: () => import("./views_mobagile/veiculos/veiculo-editar.vue"),
    },
    {
        path: "/veiculo/editar",
        meta: { authRequired: true },
        redirect: "/veiculos/list"
    },

  {
    path: "/visitas/list",
    name: "VisitaLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/visitas/visitas-list"),
  },

  {
    path: "/wmsos/list",
    name: "WmsOsLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/wmsos/wmsos-entrada-list.vue"),
  },
  {
    path: "/wmsossaida/list",
    name: "WmsOsSaidaLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/wmsos/wmsos-saida-list-nova"),
  },
  {
    path: "/wmsossaida/listnovaold",
    name: "WmsOsSaidaListaOld",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/wmsos/wmsos-saida-list"),
  },
  {
    path: "/wmsosentrada/list",
    name: "WmsOsEntradaLista",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/wmsos/wmsos-entrada-list-nova"),
  },
  {
    path: "/wmsosentrada/listnovaold",
    name: "WmsOsEntradaListaOld",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/wmsos/wmsos-entrada-list"),
  },
  {
    path: "/wmsos/editar/:id",
    name: "WmsOsEditar",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/wmsos/wmsos-entrada-editar"),
  },
  {
    path: "/wmsos/editar",
    meta: { authRequired: true },
    redirect: "/wmsos/list"
  },
  {
    path: "/wmsos/saidaeditar/:id",
    name: "WmsOsEditarSaida",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/wmsos/wmsos-saida-editar-nova"),
  },
  {
    path: "/wmsos/saidaeditar",
    meta: { authRequired: true },
    redirect: "/wmsossaida/list"
  },
  {
    path: "/wmsos/saidaeditarnova/:id",
    name: "WmsOsEditarSaidaTransp",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/wmsos/wmsos-saida-editar-nova"),
  },
  {
    path: "/wmsos/saidaleitordig/:id",
    name: "WmsOsEditarSaidaLeitorDig",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/wmsos/wmsos-saida-leitordigital"),
  },
  {
    path: "/wmsos/saidaeditarnova",
    meta: { authRequired: true },
    redirect: "/wmsossaida/list"
  },
  {
    path: "/wmsos/saidaromaeditar/:id",
    name: "WmsOsEditarSaidaRoma",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/wmsos/wmsos-saida-romaneio-editar"),
  },
  {
    path: "/wmsos/saidaromaeditar",
    meta: { authRequired: true },
    redirect: "/wmsossaida/list"
  },
  {
    path: "/wmsos/entradaeditarnova/:id",
    name: "WmsOsEditarEntrada",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/wmsos/wmsos-entrada-editar"),
  },
  {
    path: "/wmsos/entradaeditarnova",
    meta: { authRequired: true },
    redirect: "/wmsossaida/list"
  },




  // {
  //   path: "/wmsromaneios/list",
  //   name: "RomaneiosLista",
  //   meta: { authRequired: true },
  //   component: () => import("./views_mobagile/wmsromaneios/wms-romaneios-list"),
  // },
  {
    path: "/wmsromaneios/list",
    name: "RomaneiosListaNova",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/wmsromaneios/wms-romaneios-list-nova"),
  },
  {
    path: "/wmsromaneio/editar/:id",
    name: "WmsRomEditarSaida",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/wmsromaneios/wms-romaneio-editar"),
  },
  {
    path: "/wmsromaneio/expedir/:id",
    name: "WmsRomExpedir",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/wmsromaneios/wms-romaneio-expedir"),
  },
  {
    path: "/wmsos/saidaeditar",
    meta: { authRequired: true },
    redirect: "/wmsos/list"
  },
  {
    path: "/coletor/conferenciacoletor/:id",
    name: "conferenciaColetor",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/coletor/conferencia-coletor"),
  },
  {
    path: "/coletor/inventariocoletor/:id",
    name: "inventarioColetor",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/coletor/inventario-coletor"),
  },
  {
    path: "/coletor/transferenciacoletor/:id",
    name: "transferenciaColetor",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/coletor/transferencia-coletor"),
  },
  {
    path: "/coletor/recebimentocoletor/:id",
    name: "recebimentoColetor",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/coletor/recebimento-coletor"),
  },
  {
    path: "/tracking/detalhe/:id",
    name: "TrackDetalhe",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/tracking/tracking"),
  },
  {
    path: "/tracking/externo",
    name: "TrackExterno",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/tracking/tracking-externo"),
  },
  {
    path: "/tracking/externoped",
    name: "TrackExternoPed",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/tracking/tracking-externo-pedidos"),
  },
  {
    path: "/tracking/monitoramento",
    name: "TrackingMonitoramento",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/tracking/tracking-monitoramento"),
  },
  {
    path: "/tracking/depara",
    name: "TrackingDepara",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/tracking/tracking-depara"),
  },
  {
    path: "/movcte/apuracao",
    name: "MovCteApuracao",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/movcte/cte-apuracao"),
  },
  {
    path: "/integracoes/geral",
    name: "IntegracoesGeral",
    meta: { authRequired: true },
    component: () => import("./views_mobagile/integracoes/geral"),
  },

  {
    path: "/login",
    name: "login",
    // component: () => import("./views/account/login"),
    component: () => import("./views/sample-pages/login-2"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import("./views/account/logout"),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {

        // if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
        //   store.dispatch("auth/logOut");
        // } else {
        //   store.dispatch("authfack/logout");
        // }
        const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
            route.push("/login")
        );
        // Navigate back to previous page, or home as a fallback
        next(
            authRequiredOnPreviousRoute ? { name: "default" } : { ...routeFrom }
        );
      },
    },
  },
  {
    path: '/:pathMatch(.*)*',
    component: require("./views/utility/404").default,
  },



  {
    path: "/register",
    name: "Register",
    component: () => import("./views/account/register"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  // {
  //   path: "/forgot-password",
  //   name: "Forgot password",
  //   component: () => import("./views/account/forgot-password"),
  //   meta: {
  //     beforeResolve(routeTo, routeFrom, next) {
  //       // If the user is already logged in
  //       if (store.getters["auth/loggedIn"]) {
  //         // Redirect to the home page instead
  //         next({ name: "default" });
  //       } else {
  //         // Continue to the login page
  //         next();
  //       }
  //     },
  //   },
  // },


  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  // {
  //   path: "*",
  //   redirect: "404",
  // },
  // {
  //   path: "/chat",
  //   name: "chat",
  //   meta: { authRequired: true },
  //   component: () => import("./views/chat/index"),
  // },
  // {
  //   path: "/apps/file-manager",
  //   name: "file-manager",
  //   meta: { authRequired: true },
  //   component: () => import("./views/file-manager/index"),
  // },

  // {
  //   path: "/ecommerce/products",
  //   name: "Products",
  //   meta: { authRequired: true },
  //   component: () => import("./views/ecommerce/products"),
  // },

  //
  //
  // {
  //   path: "/ecommerce/product-detail/:id",
  //   name: "Product Detail",
  //   meta: { authRequired: true },
  //   component: () => import("./views/ecommerce/product-detail"),
  // },

  //
  // {
  //   path: "/ecommerce/orders",
  //   name: "Orders",
  //   meta: { authRequired: true },
  //   component: () => import("./views/ecommerce/orders"),
  // },
  // {
  //   path: "/ecommerce/customers",
  //   name: "Customers",
  //   meta: { authRequired: true },
  //   component: () => import("./views/ecommerce/customers"),
  // },
  // {
  //   path: "/ecommerce/cart",
  //   name: "Cart",
  //   meta: { authRequired: true },
  //   component: () => import("./views/ecommerce/cart"),
  // },
  // {
  //   path: "/ecommerce/checkout",
  //   name: "Checkout",
  //   meta: { authRequired: true },
  //   component: () => import("./views/ecommerce/checkout"),
  // },
  // {
  //   path: "/ecommerce/shops",
  //   name: "Shops",
  //   meta: { authRequired: true },
  //   component: () => import("./views/ecommerce/shops"),
  // },
  // {
  //   path: "/ecommerce/add-product",
  //   name: "Add Product",
  //   meta: { authRequired: true },
  //   component: () => import("./views/ecommerce/add-product"),
  // },


  // {
  //   path: "/blog/list",
  //   name: "blog-list",
  //   meta: { authRequired: true },
  //   component: () => import("./views/blog/list"),
  // },
  // {
  //   path: "/blog/grid",
  //   name: "blog-grid",
  //   meta: { authRequired: true },
  //   component: () => import("./views/blog/grid"),
  // },
  // {
  //   path: "/blog/detail",
  //   name: "blog-detail",
  //   meta: { authRequired: true },
  //   component: () => import("./views/blog/detail"),
  // },
  // {
  //   path: "/crypto/wallet",
  //   name: "Wallet",
  //   meta: { authRequired: true },
  //   component: () => import("./views/crypto/wallet/index"),
  // },
  // {
  //   path: "/crypto/buy-sell",
  //   name: "Buy/sell",
  //   meta: { authRequired: true },
  //   component: () => import("./views/crypto/buysell/index"),
  // },
  // {
  //   path: "/crypto/exchange",
  //   name: "Exchange",
  //   meta: { authRequired: true },
  //   component: () => import("./views/crypto/exchange/index"),
  // },
  // {
  //   path: "/crypto/lending",
  //   name: "Lending",
  //   meta: { authRequired: true },
  //   component: () => import("./views/crypto/lending/index"),
  // },
  // {
  //   path: "/crypto/orders",
  //   name: "crypto-orders",
  //   meta: { authRequired: true },
  //   component: () => import("./views/crypto/orders/index"),
  // },
  // {
  //   path: "/crypto/kyc-application",
  //   name: "kyc-application",
  //   meta: { authRequired: true },
  //   component: () => import("./views/crypto/kycapplication/index"),
  // },
  // {
  //   path: "/crypto/ico-landing",
  //   name: "Ico-landing",
  //   meta: { authRequired: true },
  //   component: () => import("./views/crypto/ico-landing"),
  // },
  // {
  //   path: "/invoices/detail",
  //   name: "Invoice Detail",
  //   meta: { authRequired: true },
  //   component: () => import("./views/invoices/detail"),
  // },
  // {
  //   path: "/invoices/list",
  //   name: "Invoice List",
  //   meta: { authRequired: true },
  //   component: () => import("./views/invoices/list"),
  // },
  // {
  //   path: "/ui/alerts",
  //   name: "Alerts",
  //   meta: {
  //     authRequired: true,
  //   },
  //   component: () => import("./views/ui/alerts"),
  // },
  //
  //
  // {
  //   path: "/ui/buttons",
  //   name: "Buttons",
  //   meta: {
  //     authRequired: true,
  //   },
  //   component: () => import("./views/ui/buttons"),
  // },
  // {
  //   path: "/ui/cards",
  //   name: "Cards",
  //   meta: { authRequired: true },
  //   component: () => import("./views/ui/cards"),
  // },
  // {
  //   path: "/ui/carousel",
  //   name: "Carousel",
  //   meta: { authRequired: true },
  //   component: () => import("./views/ui/carousel"),
  // },
  // {
  //   path: "/ui/dropdowns",
  //   name: "Dropdowns",
  //   meta: { authRequired: true },
  //   component: () => import("./views/ui/dropdowns"),
  // },
  // {
  //   path: "/ui/grid",
  //   name: "Grid",
  //   meta: { authRequired: true },
  //   component: () => import("./views/ui/grid"),
  // },
  // {
  //   path: "/ui/images",
  //   name: "Images",
  //   meta: { authRequired: true },
  //   component: () => import("./views/ui/images"),
  // },
  // {
  //   path: "/ui/modals",
  //   name: "Modals",
  //   meta: { authRequired: true },
  //   component: () => import("./views/ui/modals"),
  // },
  // {
  //   path: "/ui/offcanvas",
  //   name: "offcanvas",
  //   meta: { authRequired: true },
  //   component: () => import("./views/ui/offcanvas"),
  // },
  // {
  //   path: "/ui/rangeslider",
  //   name: "Rangeslider",
  //   meta: { authRequired: true },
  //   component: () => import("./views/ui/rangeslider"),
  // },
  // {
  //   path: "/ui/progressbars",
  //   name: "Progressbars",
  //   meta: { authRequired: true },
  //   component: () => import("./views/ui/progressbars"),
  // },
  // {
  //   path: "/ui/placeholder",
  //   name: "Placeholder",
  //   meta: { authRequired: true },
  //   component: () => import("./views/ui/placeholder"),
  // },
  // {
  //   path: "/ui/sweet-alert",
  //   name: "Sweet-alert",
  //   meta: { authRequired: true },
  //   component: () => import("./views/ui/sweet-alert"),
  // },
  // {
  //   path: "/ui/tabs-accordions",
  //   name: "Tabs-accordions",
  //   meta: { authRequired: true },
  //   component: () => import("./views/ui/tabs-accordions"),
  // },
  // {
  //   path: "/ui/typography",
  //   name: "Typography",
  //   meta: { authRequired: true },
  //   component: () => import("./views/ui/typography"),
  // },
  // {
  //   path: "/ui/video",
  //   name: "Video",
  //   meta: { authRequired: true },
  //   component: () => import("./views/ui/video"),
  // },
  // {
  //   path: "/ui/general",
  //   name: "General",
  //   meta: { authRequired: true },
  //   component: () => import("./views/ui/general"),
  // },
  // {
  //   path: "/ui/colors",
  //   name: "Colors",
  //   meta: { authRequired: true },
  //   component: () => import("./views/ui/colors"),
  // },
  // {
  //   path: "/ui/lightbox",
  //   name: "Lightbox",
  //   meta: { authRequired: true },
  //   component: () => import("./views/ui/lightbox"),
  // },
  // {
  //   path: "/ui/image-cropper",
  //   name: "Image Cropper",
  //   meta: { authRequired: true },
  //   component: () => import("./views/ui/cropper"),
  // },
  // {
  //   path: "/projects/grid",
  //   name: "Projects Grid",
  //   meta: { authRequired: true },
  //   component: () => import("./views/projects/projects-grid"),
  // },
  // {
  //   path: "/projects/list",
  //   name: "Projects List",
  //   meta: { authRequired: true },
  //   component: () => import("./views/projects/projects-list"),
  // },
  // {
  //   path: "/projects/overview",
  //   name: "Project Overview",
  //   meta: { authRequired: true },
  //   component: () => import("./views/projects/overview"),
  // },
  // {
  //   path: "/projects/create",
  //   name: "Create New",
  //   meta: { authRequired: true },
  //   component: () => import("./views/projects/create"),
  // },
  // {
  //   path: "/contacts/grid",
  //   name: "User Grid",
  //   meta: { authRequired: true },
  //   component: () => import("./views/contacts/contacts-grid"),
  // },
  // {
  //   path: "/contacts/list",
  //   name: "User List",
  //   meta: { authRequired: true },
  //   component: () => import("./views/contacts/contacts-list"),
  // },
  // {
  //   path: "/contacts/profile",
  //   name: "Profile",
  //   meta: { authRequired: true },
  //   component: () => import("./views/contacts/contacts-profile"),
  // },
  // {
  //   path: "/charts/apex",
  //   name: "Apex chart",
  //   meta: { authRequired: true },
  //   component: () => import("./views/charts/apex"),
  // },
  // {
  //   path: "/charts/chartjs",
  //   name: "Chartjs chart",
  //   meta: { authRequired: true },
  //   component: () => import("./views/charts/chartjs/index"),
  // },
  // {
  //   path: "/charts/chartist",
  //   name: "Chartist chart",
  //   meta: { authRequired: true },
  //   component: () => import("./views/charts/chartist"),
  // },
  // {
  //   path: "/charts/echart",
  //   name: "Echart chart",
  //   meta: { authRequired: true },
  //   component: () => import("./views/charts/echart/index"),
  // },
  // {
  //   path: "/icons/boxicons",
  //   name: "Boxicons Icon",
  //   meta: { authRequired: true },
  //   component: () => import("./views/icons/boxicons"),
  // },
  // {
  //   path: "/icons/materialdesign",
  //   name: "Materialdesign Icon",
  //   meta: { authRequired: true },
  //   component: () => import("./views/icons/materialdesign"),
  // },
  // {
  //   path: "/icons/dripicons",
  //   name: "Dripicons Icon",
  //   meta: { authRequired: true },
  //   component: () => import("./views/icons/dripicons"),
  // },
  // {
  //   path: "/icons/fontawesome",
  //   name: "Fontawesome Icon",
  //   meta: { authRequired: true },
  //   component: () => import("./views/icons/fontawesome"),
  // },
  // {
  //   path: "/maps/google",
  //   name: "Google Maps",
  //   meta: { authRequired: true },
  //   component: () => import("./views/maps/google"),
  // },
  // {
  //   path: "/maps/leaflet",
  //   name: "Leaflet Maps",
  //   meta: { authRequired: true },
  //   component: () => import("./views/maps/leaflet/index"),
  // },
  // {
  //   path: "/tables/basic",
  //   name: "Basic Tables",
  //   meta: { authRequired: true },
  //   component: () => import("./views/tables/basictable"),
  // },
  // {
  //   path: "/form/advanced",
  //   name: "Form Advanced",
  //   meta: { authRequired: true },
  //   component: () => import("./views/forms/advanced"),
  // },
  // {
  //   path: "/form/elements",
  //   name: "Form Elements",
  //   meta: { authRequired: true },
  //   component: () => import("./views/forms/elements"),
  // },
  // {
  //   path: "/form/layouts",
  //   name: "Form Layouts",
  //   meta: { authRequired: true },
  //   component: () => import("./views/forms/layouts"),
  // },
  // {
  //   path: "/form/editor",
  //   name: "Form Editors",
  //   meta: { authRequired: true },
  //   component: () => import("./views/forms/editors"),
  // },
  // {
  //   path: "/form/uploads",
  //   name: "File Uploads",
  //   meta: { authRequired: true },
  //   component: () => import("./views/forms/uploads"),
  // },
  // {
  //   path: "/form/validation",
  //   name: "Form Validation",
  //   meta: { authRequired: true },
  //   component: () => import("./views/forms/validation"),
  // },
  // {
  //   path: "/form/wizard",
  //   name: "Form Wizard",
  //   meta: { authRequired: true },
  //   component: () => import("./views/forms/wizard"),
  // },
  // {
  //   path: "/form/repeater",
  //   name: "Form Repeater",
  //   meta: { authRequired: true },
  //   component: () => import("./views/forms/repeater"),
  // },
  // {
  //   path: "/form/mask",
  //   name: "Form Mask",
  //   meta: { authRequired: true },
  //   component: () => import("./views/forms/mask"),
  // },
  // {
  //   path: "/pages/starter",
  //   name: "Starter",
  //   meta: { authRequired: true },
  //   component: () => import("./views/utility/starter"),
  // },
  // {
  //   path: "/pages/maintenance",
  //   name: "Maintenance",
  //   meta: { authRequired: true },
  //   component: () => import("./views/utility/maintenance"),
  // },
  // {
  //   path: "/pages/coming-soon",
  //   name: "coming-soon",
  //   meta: { authRequired: true },
  //   component: () => import("./views/utility/coming-soon"),
  // },
  // {
  //   path: "/pages/timeline",
  //   name: "Timeline",
  //   meta: { authRequired: true },
  //   component: () => import("./views/utility/timeline"),
  // },
  // {
  //   path: "/pages/faqs",
  //   name: "FAQs",
  //   meta: { authRequired: true },
  //   component: () => import("./views/utility/faqs"),
  // },
  // {
  //   path: "/pages/pricing",
  //   name: "Pricing",
  //   meta: { authRequired: true },
  //   component: () => import("./views/utility/pricing"),
  // },
  // {
  //   path: "/pages/404",
  //   name: "Error-404",
  //   meta: { authRequired: true },
  //   component: () => import("./views/utility/404"),
  // },
  // {
  //   path: "/pages/500",
  //   name: "Error-500",
  //   meta: { authRequired: true },
  //   component: () => import("./views/utility/500"),
  // },
  // {
  //   path: "/email/inbox",
  //   name: "Inbox",
  //   meta: { authRequired: true },
  //   component: () => import("./views/email/inbox"),
  // },
  // {
  //   path: "/email/reademail/:id",
  //   name: "Read Email",
  //   meta: { authRequired: true },
  //   component: () => import("./views/email/reademail"),
  // },
  // {
  //   path: "/email/templates/basic",
  //   name: "Email template basic",
  //   meta: { authRequired: true },
  //   component: () => import("./views/email/templates/basic"),
  // },
  // {
  //   path: "/email/templates/billing",
  //   name: "Email template billing",
  //   meta: { authRequired: true },
  //   component: () => import("./views/email/templates/billing"),
  // },
  // {
  //   path: "/email/templates/alert",
  //   name: "Email template alert",
  //   meta: { authRequired: true },
  //   component: () => import("./views/email/templates/alert"),
  // },
  // {
  //   path: "/tasks/list",
  //   name: "Task list",
  //   meta: { authRequired: true },
  //   component: () => import("./views/tasks/task-list"),
  // },
  // {
  //   path: "/tasks/kanban",
  //   name: "Kanbanboard",
  //   meta: { authRequired: true },
  //   component: () => import("./views/tasks/kanbanboard"),
  // },
  // {
  //   path: "/tasks/create",
  //   name: "Create Task",
  //   meta: { authRequired: true },
  //   component: () => import("./views/tasks/task-create"),
  // },
  // {
  //   path: "/auth/login-1",
  //   name: "Login sample",
  //   meta: { authRequired: true },
  //   component: () => import("./views/sample-pages/login-sample"),
  // },
  // {
  //   path: "/auth/login-2",
  //   name: "Login-2-sample",
  //   meta: { authRequired: true },
  //   component: () => import("./views/sample-pages/login-2"),
  // },
  // {
  //   path: "/auth/register-1",
  //   name: "Register sample",
  //   meta: { authRequired: true },
  //   component: () => import("./views/sample-pages/register-sample"),
  // },
  // {
  //   path: "/auth/register-2",
  //   name: "Register-2",
  //   meta: { authRequired: true },
  //   component: () => import("./views/sample-pages/register-2"),
  // },
  // {
  //   path: "/auth/recoverpwd",
  //   name: "Recover pwd",
  //   meta: { authRequired: true },
  //   component: () => import("./views/sample-pages/recoverpw-sample"),
  // },
  // {
  //   path: "/auth/recoverpwd-2",
  //   name: "Recover pwd-2",
  //   meta: { authRequired: true },
  //   component: () => import("./views/sample-pages/recoverpwd-2"),
  // },
  // {
  //   path: "/auth/lock-screen",
  //   name: "Lock screen",
  //   meta: { authRequired: true },
  //   component: () => import("./views/sample-pages/lockscreen"),
  // },
  // {
  //   path: "/auth/lock-screen-2",
  //   name: "Lock screen-2",
  //   meta: { authRequired: true },
  //   component: () => import("./views/sample-pages/lockscreen-2"),
  // },
  // {
  //   path: "/auth/confirm-mail",
  //   name: "confirm-mail",
  //   meta: { authRequired: true },
  //   component: () => import("./views/sample-pages/confirm-mail"),
  // },
  // {
  //   path: "/auth/confirm-mail-2",
  //   name: "confirm-mail-2",
  //   meta: { authRequired: true },
  //   component: () => import("./views/sample-pages/confirm-mail-2"),
  // },
  // {
  //   path: "/auth/email-verification",
  //   name: "email-verification",
  //   meta: { authRequired: true },
  //   component: () => import("./views/sample-pages/email-verification"),
  // },
  // {
  //   path: "/auth/email-verification-2",
  //   name: "email-verification-2",
  //   meta: { authRequired: true },
  //   component: () => import("./views/sample-pages/email-verification-2"),
  // },
  // {
  //   path: "/auth/two-step-verification",
  //   name: "two-step-verification",
  //   meta: { authRequired: true },
  //   component: () => import("./views/sample-pages/two-step-verification"),
  // },
  // {
  //   path: "/auth/two-step-verification-2",
  //   name: "two-step-verification-2",
  //   meta: { authRequired: true },
  //   component: () => import("./views/sample-pages/two-step-verification-2"),
  // },

];
